import { jsx } from "react/jsx-runtime";
import NotesIcon from "@mui/icons-material/Notes";
import { validateTidalLicense } from "../../base/index.js";
function Notes(props) {
  return /* @__PURE__ */ jsx(
    NotesIcon,
    {
      "data-testid": "Notes",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "Notes",
      "data-tidal-icon-meta": "common,navigation"
    }
  );
}
Notes.tidalIconMeta = {
  categories: "common,navigation",
  name: "Notes"
};
validateTidalLicense();
export {
  Notes
};
//# sourceMappingURL=Notes.js.map
